import { Controller } from "@hotwired/stimulus"
import { get, destroy } from "@rails/request.js"

export default class extends Controller {
  // adresIdTarget = element waar gekozen adres-id in moet
  // adresStringTarget = element waar gekozen adres-string in moet
  static targets = ["adresId", "adresString", "lijstFrame", "buttonsFrame", "adresboekModal", "formModal", "formFrame" ]

  // Laad modal contents
  open(event) {
    this.emptyAdresboekFrames()
    this.load_modal(event)
  }

  // Bevestig keuze adres
  // Site: keuze wordt in bovenliggende formulier gezet ahv adresId en adresString targets
  // KRS: keuze wordt direct in model verwerkt
  bevestig(event) {
    event.preventDefault()
    const checked = this.element.querySelector('input[name="selecteer_adres_radio"]:checked')
    if (checked && this.hasAdresIdTarget) {
      this.adresIdTarget.value = checked.value
    }
    if (checked && this.hasAdresStringTarget) {
      var own = document.getElementById(`owner_string_${checked.value}`).innerHTML
      var adr = document.getElementById(`adres_string_${checked.value}`).innerHTML
      this.adresStringTarget.value = `${own}\n${adr}`
    }
  }

  open_form(event) {
    event.preventDefault()
    this.emptyFormFrames()
    this.load_modal(event)
  }

  async verwijder_wijziging(event) {
    event.preventDefault()
	window.showSpinner();
    const response = await destroy(`${event.params.url}`,
      {
        responseKind: "turbo-stream",
      },
    )
    if (!response.ok) {
      console.error("Something went wrong.")
    }
	window.hideSpinner();
  }

  async verwijder_adres(event) {
    event.preventDefault()
	window.showSpinner();
    const response = await destroy(`${event.params.url}`,
      {
        responseKind: "turbo-stream",
      },
    )
    if (!response.ok) {
      console.error("Something went wrong.")
    }
	window.hideSpinner();
  }

  emptyAdresboekFrames() {
    this.lijstFrameTarget.innerHTML = ''
    this.buttonsFrameTarget.innerHTML = ''
  }

  emptyFormFrames() {
    this.formFrameTarget.innerHTML = ''
  }

  // Wordt gebruikt voor het laden van de modal.
  // De event-param bevat een url die geladen wordt
  async load_modal(event) {
	window.showSpinner();
	let url = event.params.url
    if (this.hasAdresIdTarget) {
        let separator = url.includes('?') ? '&' : '?'
        url = url + separator + `selected=${this.adresIdTarget.value}`
    }
    console.log('load_modal url:', url);
    const response = await get(url, { responseKind: "turbo-stream" })
    if (!response.ok) {
      console.error("Something went wrong.")
    }
	window.hideSpinner();
  }

  close_modal(event) {
    const form =
      event.target.form ||
      document.getElementById(event.target.getAttribute("form"))
    form.addEventListener(
      "turbo:submit-end", (e) => {
        if (e.detail.success) {
          const elem = this.formModalTarget
          const modal = bootstrap.Modal.getInstance(elem)
          if (modal) {
            modal.hide()
          }
          // Via eventlistener op de animatie tijd te geven
          elem.addEventListener(
            "hidden.bs.modal",
            () => {
              const adresboekElement = this.adresboekModalTarget
              // const adresboekModal = new bootstrap.Modal(adresboekElement)
              const adresboekModal = bootstrap.Modal.getInstance(adresboekElement)
              if (adresboekModal) {
                adresboekModal.show()
              }
            },
            { once: true },
          )
        }
      },
      { once: true },
    )
  }
}
